import { FORMAT_ID } from 'app/constants/displayBib';

// Formats whose About section uses the research-oriented layout (ResearchAbout) instead of the
// standard one -- archival, manuscript, microform and rare material, where the bibliographic
// fields worth surfacing differ from a general-collection item.
export const RESEARCH_FORMATS = [
  FORMAT_ID.ARCHIVAL_COLLECTION,
  FORMAT_ID.ARCHIVAL_CONTAINER,
  FORMAT_ID.ARCHIVAL_OBJECT_DIGITAL,
  FORMAT_ID.ARCHIVAL_OBJECT,
  FORMAT_ID.MANUSCRIPT,
  FORMAT_ID.MICROFORM,
  FORMAT_ID.RARE_BK
];

export function isResearchFormat(format) {
  return RESEARCH_FORMATS.includes(format);
}

/**
 * Whether the bib page should render `<ResearchAbout>` in place of `<About>`.
 *
 * Both conditions have to hold: the library has the setting enabled, and this bib is one of the
 * research formats. Extracted from BibPage.render so the decision can be tested across every
 * format without mounting the page and its connected section subtree (CORE-78542).
 *
 * @param {Immutable.Map} catalogBib        the bib; format is read from `brief.format`
 * @param {boolean}       showResearchAbout the library's `showResearchAbout` setting
 * @returns {boolean}
 */
export default function shouldShowResearchAbout(catalogBib, showResearchAbout) {
  return Boolean(showResearchAbout) && isResearchFormat(catalogBib.getIn(['brief', 'format']));
}
